export default {
  2: {
    //观看视频30分钟
    icon: 'icon-watch',
    btn: '去观看',
  },

  3: {
    // 打开消息通知
    icon: 'icon-news',
    btn: '去打开',
  },
  5: {
    // 写条评论
    icon: 'icon-comment',
    btn: '去评论',
  },
  6: {
    //分享视频
    icon: 'icon-share',
    btn: '去分享',
  },
  7: {
    // 发表弹幕
    icon: 'icon-danmu',
    btn: '去发表',
  },
  8: {
    // 绑定手机
    icon: 'icon-bind',
    btn: '去绑定',
  },
  9: {
    // 新手看视频奖励
    icon: 'icon-new',
    btn: '去观看',
  },
  14: {
    // 芒果崽
    icon: 'icon-exploring',
    btn: '去探班',
  },
  18: {
    //'芒果影视城'
    icon: 'icon-mgmovie',
    btn: '去建设',
  },
  19: {
    // '歌手评论'
    icon: 'icon-singer',
    btn: '去评论',
  },
  20: {
    // '观看短视频5分钟'
    icon: 'icon-video',
    btn: '去观看',
  },
  21: {
    // '有效观看短视频6个'
    icon: 'icon-video',
    btn: '去观看',
  },
  22: {
    // 广告
    icon: 'icon-video',
    btn: '去观看',
  },
  23: {
    // '每天关注两位大芒创作者'
    icon: 'icon-focus',
    btn: '去关注',
  },
  24: {
    // '去关注10位大芒创作者'
    icon: 'icon-focus',
    btn: '去关注',
  },
  25: {
    // '去抓娃娃'
    icon: 'icon-catch',
    btn: '去抓取',
  },
  26: {
    // '建党百年积分任务'
    icon: 'icon-singer',
    btn: '去完成',
  },
  27: {
    // '首次下载小芒APP'
    icon: 'icon-ecom',
    btn: '去下载',
  },
  28: {
    // '完成连续包月（3个月内限1次）'
    icon: 'icon-vip',
    btn: '去完成',
  },
  29: {
    // '关注[芒果TV会员]公众号'
    icon: 'icon-add',
    btn: '去关注',
  },
  30: {
    // '浏览会员日活动页面15秒'
    icon: 'icon-view',
    btn: '去看看',
  },
  31: {
    // '观看会员片单15秒'
    icon: 'icon-view',
    btn: '去看看',
  },
  33: {
    // '邀请好友一起看视频'
    icon: 'icon-add',
    btn: '去邀请',
  },
  35: {
    // '浏览芒果公益项目'
    icon: 'icon-35',
    btn: '去浏览',
  },
  36: {
    // '添加会员福利官微信好友'
    icon: 'icon-add',
    btn: '去添加',
  },
  37: {
    // '参与芒果农场游戏1次'
    icon: 'icon-37',
    btn: '去参与',
  },
  38: {
    // '合唱团'
    icon: 'icon-chorus',
    btn: '去加入',
  },
  39: {
    // '逛逛一起看广场'
    icon: 'icon-add',
    btn: '去邀请',
    showTitleIcon: true,
  },
  40: {
    icon: 'icon-view',
    btn: '去浏览',
  },
  41: {
    icon: 'icon-view',
    btn: '去浏览',
  },
  42: {
    icon: 'icon-view',
    btn: '去浏览',
  },
  43: {
    icon: 'icon-view',
    btn: '去浏览',
  },
  44: {
    icon: 'icon-view',
    btn: '去浏览',
  },
}
